import React from "react";

import { Content } from "./styles";

interface ContentProps {
  children: React.ReactNode;
}

export function ContentComponent({ children }: ContentProps) {
  return <Content>{children}</Content>;
}
